<template>
  <main id="sample my-2">
    <Editor
      v-model="editorContent"
      api-key="5kpaz9w8s4cd4g2pczfp7zpqveia5buck8vym899jsyk0sut"
      :init="init"
    />
  </main>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import mainBaseUrl from "@/global-components";
import { CreateFile, UploadFile } from "@/libs/Api/Media";

export default {
  name: "TinyMCE",
  data() {
    return {
      editorContent: null,
      init: {
        height: 600,
        image_caption: true,
        plugins:
          "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion",
        file_picker_types: "image media",
        toolbar:
          "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl",
        automatic_uploads: true,
        importcss_append: true,
        quickbars_selection_toolbar:
          "bold italic | quicklink h2 h2 blockquote quickimage quicktable",
        contextmenu: "link image table",
        file_picker_callback: (cb, value, meta) => {
          // Create file input
          const input = document.createElement("input");
          input.setAttribute("type", "file");

          // Provide file and text for the link dialog
          if (meta.filetype == "file") {
            cb("mypage.html", { text: "My text" });
          }

          // Provide image and alt text for the image dialog
          if (meta.filetype == "image") {
            input.setAttribute("accept", "image/*");

            input.addEventListener("change", async (e) => {
              const file = e.target.files[0];
              let result = null;

              let formData = new FormData();
              formData.append("File", file);
              formData.append("Type", 8);
              formData.append("mediaType", 30);
              formData.append("ObjectId", -1);
              formData.append("alt", "");
              try {
                let _this = this;
                let createFile = new UploadFile(_this);
                createFile.setParams(formData);
                await createFile.sendFormData(
                  (response) => {
                    // debugger
                    result = response.link;
                    cb(result, { alt: "" });
                  },
                  (error) => {
                    console.log(error);
                  }
                );
              } catch (error) {
                console.error(error);
              }
            });
          }

          // Provide alternative source and posted for the media dialog
          if (meta.filetype == "media") {
            input.setAttribute("accept", "video/*");

            input.addEventListener("change", async (e) => {
              const file = e.target.files[0];
              let result = null;

              let formData = new FormData();
              formData.append("File", file);
              formData.append("Type", 8);
              formData.append("mediaType", 30);
              formData.append("ObjectId", -1);
              formData.append("alt", "");
              try {
                let _this = this;
                let createFile = new UploadFile(_this);
                createFile.setParams(formData);
                await createFile.sendFormData(
                  (response) => {
                    // debugger
                    result = response.link;
                    cb(result, { source2: "", poster: "" });
                  },
                  (error) => {
                    console.log(error);
                  }
                );
              } catch (error) {
                console.error(error);
              }
            });
          }

          input.click();
        },
      },
    };
  },
  watch: {
    editorContent: {
      handler(val) {
        this.$emit("getEditorContent", val);
      },
    },
  },
  props: {
    defaultEditorContent: {
      required: false,
    },
  },
  mounted() {
    if (this.defaultEditorContent) {
      setTimeout(() => {
        this.editorContent = this.defaultEditorContent;
      }, 300);
    }
  },
  components: {
    Editor,
  },
};
</script>

<style scoped></style>
